/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum TimeAvailabilityDisabledReason {
  MAX_STATIONS_RESTRICTION = 'max_stations_restriction',
  CUSTOM_TICKET_HIDDEN_FROM_CUSTOMERS = 'custom_ticket_hidden_from_customers',
  MORE_PERSONS_THEN_TICKETS = 'more_persons_then_tickets',
  INTERSECTION_WITH_PREVIOUS_ORDER = 'intersection_with_previous_order',
  PERSONS_OPEN_EMPTY_EVENT = 'persons_open_empty_event',
  UNAVAILABILITY_INTERSECT = 'unavailability_intersect',
  MAX_DETAIL_RESTRICTION_UNAVAILABILITY = 'max_detail_restriction_unavailability',
  MAX_DETAIL_RESTRICTION = 'max_detail_restriction',
  MAX_PARALLEL_PERSONS = 'max_parallel_persons',
  MAX_PARALLEL_CAPACITY = 'max_parallel_capacity',
  USER_AVAILABILITY = 'user_availability',
  NO_TICKETS_LEFT = 'no_tickets_left',
  RESOURCE_CAPACITY_EXCEEDED = 'resource_capacity_exceeded',
  MAX_PARALLEL_WORKSHOPS = 'max_parallel_workshops',
  VOUCHER_PERCENTAGE_LIMIT = 'voucher_percentage_limit',
  PER_TICKET_CAPACITY_EXCEEDED = 'per_ticket_capacity_exceeded',
  BLOCKED_BY_EMPTY_EVENT_RESERVATION = 'blocked_by_empty_event_reservation',
  BLOCKED_BY_RECURRING_EVENT_SCHEDULE = 'blocked_by_recurring_event_schedule',
}
